export default {
    lang: "塞尔维亚语",
    application: {
        name: "Систем за објављивање информација",
    },
    ajaxTip: {
        success: "Успешно",
        error: "Неуспешно",
        noAccess: "Немате приступ овим ресурсима",
        notFound: "Приступни ресурс не постоји",
        serverBusy: "Сервер је заузет",
        timeOut: "Истекло време чекања",
    },
    menu: {
        home: "Почетна страница",
        template: "Управљање шаблонима",
        program: "Управљање програмима",
        playplan: "План постављања",
        device: "Управљање уређајима",
        "source-material": "Управљање материјалима",
        material: "Материјал",
        checkManage: "Управљање провером",
        setting: "Поставке",
        usercenter: "Кориснички центар",
        adminManage: "Управљање уређајима",
        schedule: "Задаци на чекању",
        capitalassets: "Управљање капиталним имовином",
        modifyPassword: "Измени лозинку",
        logout: "Одјави се",
        "add": "Додај",
        "edit": "Уреди",
        "delete": "Обриши",
        "view": "Прегледај",
        "menu_1": "Почетна страница",
        "menu_2": "Управљање уређајима",
        "menu_3": "Уреди (Напредне поставке - Основно уређивање - Промени мрежу)",
        "menu_4": "Имедијатне наредбе",
        "menu_5": "Уреди (Пребаци одељење)",
        "menu_6": "Стратегија",
        "menu_7": "Поставке звукова",
        "menu_8": "Поставке светлости",
        "menu_9": "Поставке преузимања",
        "menu_10": "Поставке сна",
        "menu_11": "Особине уређаја",
        "menu_12": "Уреди/Додај",
        "menu_13": "Управљање програмима",
        "menu_14": "Историјат објављивања",
        "menu_15": "Обриши (Групово/Појединачно)",
        "menu_16": "Програми у процесу објављивања",
        "menu_17": "Групирање",
        "menu_19": "Листа програма",
        "menu_20": "Уређивање садржаја",
        "menu_21": "Копирај програм",
        "menu_23": "Објави програм",
        "menu_24": "Управљање материјалима",
        "menu_25": "Постави на мрежу",
        "menu_28": "Брзо објављивање",
        "menu_29": "Управљање шаблонима",
        "menu_30": "Јавни шаблони",
        "menu_31": "Користи одмах",
        "menu_32": "Моји шаблони",
        "menu_33": "Објави у јавне шаблоне",
        "menu_35": "Историјат делења",
        "menu_36": "Управљање провером",
        "menu_37": "Провера програма",
        "menu_38": "Провера (Одобри/Одбиј)",
        "menu_39": "Провера материјала",
        "menu_41": "Историјат провере (Оператор)",
        "menu_42": "Историјат провере (Проверач)",
        "menu_43": "Прегледај број одобрења",
        "menu_44": "Управљање организацијом",
        "menu_45": "Управљање дневницима",
        "menu_46": "Дневници воспроизведења",
        "menu_47": "Дневници објављивања",
        "menu_48": "Дневници грешака",
        "menu_49": "Дневници операција",
        "menu_50": "Дневници фајлова",
        "menu_51": "Дневници пријављивања",
        "menu_52": "Одобрење садржаја",
        "menu_53": "Простор за складиштење",
        "menu_54": "Организациона структура",
        "menu_55": "Права улога",
        "menu_56": "Авторизација",
        "menu_57": "Прегледај (Права на авторизацију)",
        "menu_58": "Чланови организације",
        "menu_60": "Ресетуј лозинке подредених корисника",
        "menu_61": "Управљање активIMA",
        "menu_62": "Мој остатак",
        "menu_63": "Прегледај (Детаљи środстава)",
        "menu_64": "Мој трафик",
        "menu_65": "Прегледај (Детаљи трафика)",
        "menu_66": "Купи трафик",
        "menu_67": "Моја капацитет",
        "menu_68": "Моји уређаји",
        "menu_69": "Детаљи наруџбине",
        "menu_70": "Прегледај (Наплати)",
        "menu_71": "Прегледај (Купљени шаблони)",
        "menu_72": "Прегледај (Купљени трафик)",
        "menu_73": "Остала права",
        "menu_74": "Прегледај (Статистика материјала и програма)",
        "menu_75": "Прегледај (Активы)",
        "menu_76": "Прегледај (Облачни трафик/Статистика)",
        "menu_77": "Прегледај (Статистика онлајн уређаја)"
    },
    login: {
        terminalServiceSystem: "Паметни систем за сервис терминала",
        accountLogin: "Пријавите се на налог",
        register: "Региструј се",
        accountLoginTip: "Имате налог? Пријавите се",
        scanQRCode: "Скенирајте двоструки штрих код",
        readAndAgree: "Прочитао/ла сам и согласан/на",
        readAndAgreeLink: "Услови коришћења сервиса",
        readAndAgreeAgreement: "Молимо прочитајте и прихватите Услове коришћења сервиса",
        forgetpassword: "Заборавили сте лозинку?",
        resetpassword: "Ресетујте лозинку",
        phoneEmptyTip: "Унесите број мобилног телефона",
        nextStep: "Следећи корак",
        title: "Добродошли, пријавите се",
        submit: "Пријавите се",
        userName: "Назив налога",
        password: "Лозинка",
        userNameEmptyTip: "Унесите назив налога",
        passwordEmptyTip: "Унесите лозинку",
        passwordFormatTip: "Унесите исправан формат лозинке",
        passwordIsOk: "Унесите потврду лозинке",
        passwordSign: "Унесите лозинку",
        codeTip: "Унесите верификациони код",
        phone: "Број мобилног телефона не може бити празан",
        code: "Верификациони код не може бити празан",
        nickname: "Назив компаније не може бити празан",
        pass: "Лозинка не може бити празна",
        pwdMessage: "Лозинка мора имати 8~20 карактера, без размака и мора садржати 3 од следећих: велика слова, мала слова, цифре, специјални карактери",
        pwdMessage01: "Унесите лозинку са словама и цифрама, најмање осам карактера",
        pwdMessage02: "Лозинка мора имати 8-20 карактера",
        pwdMessage03: "Лозинка не сме садржати размаке",
        pwdMessage04: "Лозинка мора садржати 3 од следећих: велика слова, мала слова, цифре, симболи",
        newpassempty: "Нова лозинка не може бити празна",
        newpass: "Две уписане лозинке се не поклапају",
        getcode: "Добијите верификациони код",
        format: "Неправилан формат броја мобилног телефона",
        chongfa: "Поновно шаљење за ",
        isSend: "Послато",
        noregister: "Немате налог? Региструјте се одмах",
        Mobile: "Број мобилног телефона",
        verificationcode: "Верификациони код",
        petname: "Надимак",
        Quickregistration: "Брза регистрација",
        xiugaimima: "Измени лозинку",
        jiumima: "Стара лозинка",
        xinmima: "Нова лозинка",
        zaicishuruxinmima: "Поново унесите нову лозинку",
        xiugaichenggong: "Измена успешна",
        xiugaishoujihao: "Измени број мобилног телефона",
        dengluzhanghao: "Назив налога за пријаву",
        gongsiid: "ИД компаније",
        yonghunicheng: "Надимак корисника",
        chuangjianshijian: "Време креирања",
        gongsimingcheng: "Назив компаније",
        denglumima: "Лозинка за пријаву",
        jianyi: "Предлаже се коришћење лозинке са комбинацијом слова и цифара",
        shezhimima: "Поставите лозинку",
        shezhishoujihao: "Измени/постави број мобилног телефона",
        yibangding: "Већ повезано",
        weibangding: "Није повезано",
        zhanghuanquan: "Безбедност налога",
        yonghuxinxi: "Информације о кориснику",
        zhuceSucMsg: "Честитамо, регистрација успешна!",
        verificationcodeSucMsg: "Верификациони код је успешно послат！",
        requiredIsEmpty: "Обавезна поља не могу бити празна！",
        emailObj: {
            title: "Е-пошта",
            tit: "Пријава преко е-поште",
            tip: "Унесите адресу е-поште",
            formatTip: "Унесите исправну адресу е-поште",
        },
        phoneObj: {
            title: "Број мобилног телефона",
            tit: "Пријава преко мобилног телефона",
            tip: "Унесите број мобилног телефона",
            formatTip: "Унесите исправан број мобилног телефона",
        },
        emailOrPhoneObj: {
            title: "Е-пошта или број мобилног телефона",
            tit: "Пријава преко е-поште или мобилног телефона",
            tip: "Унесите е-пошту или број мобилног телефона",
            formatTip: "Унесите исправну е-пошту или број мобилног телефона",
        },
        wechatObj: {
            title: "ВеЧат",
            tit: "Пријава преко ВеЧата",
        },
        googleObj: {
            title: "Гугл",
            tit: "Пријава преко Гугла",
        },
        confirm: "Потврдите",
        confirmSubmit: "Потврдите и пошаљите",
        cancel: "Откажите",
        close: "Затворите",
        bindSucMsg: "Повезивање успешно",
        toContinueBindAccount: "Наставите да завршите повезување трећег страна налога",
        bindTip01: "Немате налог? Региструјите се",
        bindTip02: "Имате налог",
        bindTip03: "Тренутни налог трећег страна није повезан са налогом платформе. Молимо повежите постојећи налог или региструјте и повежите нови налог, тако да ћете мочете брзо пријавити се следећи пут.",
        bindTip04: "Повежи постојећи налог",
        bindTip05: "Региструј и повежите нови налог",
        bindTip06: "Успешно сте ауторизовали се преко трећег страна. Допуните следеће информације за пријаву да бисте завршили повезување",
        bindSubmit: "Пошаљите повезување",
        enterAccountTip: "Унесите назив налога",
        RegisterAndBind: "Региструј и повежите",
        loginErr: "Назив корисника или лозинка нетачни！",
        usercenter: "Кориснички центар",
        pleaseInputName: "Унесите назив",
        operationSuccess: "Операција успешна！",
        edit: "Уреди",
        xiugai: "Измени",
        userData: "Лични подаци",
        changePassword: "Измена лозинке",
        account: "Назив налога",
        userName01: "Назив корисника",
        phoneNumber: "Број мобилног телефона",
        role: "Улога",
        createTime: "Време креирања",
        genghuang: "Измени",
        bangding: "Повежи",
        unbind: "Разповежите",
        plesaseSelectBindingType: "Изберите тип повезувања",
        pleaseConfirmCont: "Потврдите да сте прочитао/ла овај садржај",
        confirmReadCont: "Прочитао/ла сам овај садржај",
        frequentTip: "Превише честа операција, молимо покушајте поново касније!",
        zhuxiaoBtn: "Откажите налог",
        zhuxiaoTitle: "Отказивање налога",
        querenZhuxiao: "Потврдите отказивање",
        jiXu: "Наставите",
        sendCodeBtn: "Пошаљите верификациони код",
        passwordIsNotOldPassword: "Потврдна лозинка се не поклапа са новом лозинком",
        passwordIsOldPassword: "Нова лозинка је иста као стара лозинка",
        passFormatError: "Унесите исправан формат лозинке",
        oldPassWord: "Стара лозинка",
        newPassWord: "Нова лозинка",
        inputPlaceholder: "Унесите",
        confirmPassword: "Потврдите лозинку",
        zhuxiaoTip: `
            1、Отказивање налога је необратива операција. Након отказивања налога, више нећете моћи да се пријавите и користите овај налог или налоге трећих страна регистроване преко овог налога. Молимо ручно снимите све податке и информације повезане са налогом.
            2、Пре регистрације овог налога, морате потврдити да сте обрисали све имовине и да не постоје никакве спорове; након отказивања налога, сматра се да сте отказали власност над свим имовинама и привилегијама унутар налога, које не могу бити поново враћене или пронађене.
            3、Ако је налог регистрован на исти број мобилног телефона отказан укупно 3 пута, тај број мобилног телефона више неће моћи да региструје нови налог, као ни да се повежу са другим налозима.
        `
    },
    home: {
        title: "Почетна страница",
        quickOperation: "Брзе операције",
        addDevice: "Додај уређај",
        publishProgram: "Објавите програм",
        publishMaterial: "Објавите материјал",
        makeProgram: "Направите програм",
        uploadMaterial: "Отпремите материјал",
        todayData: "Данашњи подаци (ажурирање сваке сате)",
        playNumChart: "Статистика броја постављања",
        deviceOnlineStatus: "Статус повезаности уређаја",
        onLineDevice: "Уређаји у мрежи",
        unLineDevice: "Уређаји ван мреже",
        programPlayTime: "Статистика трајања постављања програма",
        downloadSoft: "Преузмање софтвера",
        adminApp: "Мобилно корисничко прегледање",
        playerApp: "Терминал за постављање објављених информација",
        downloadAdminApp: "Кликните за преузмање корисничког прегледања",
        downloadPlayerApp: "Кликните за преузмање прегледања за постављање",
        aboutUs: "О нама",
        userManual: "Кориснички руковод",
        message: "Пошаљите поруку",
    },
    device: {
        inputPlaceholder: "Унесите",
        selectPlaceholder: "Изберите",
        osTypeStr: "Систем терминала",
        onLineStatus: "Статус повезаности",
        dpi: "Разрешение",
        companyDeptIdName: "Припадајућа организација",
        deviceGroupIdName: "Припадајућа група",
        editOrMove: "Уреди/премести",
        loanOriginationFee: "Трошак оформљања кредита",
        strategyInfoLook: "Преглед информација о стратегији",
        programLook: "Преглед програма",
        addEquipments: "Додај уређаје",
        luminanceSet: "Контрола осветљености",
        terminal: "Поставке терминала",
        transferCompany: "Пребаци одељење",
        releasedProgram: "Објављен програм",
        screenshot: "Снимак екрана",
        changeGroup: "Промените групу",
        defaultGroup: "Подразумевана група",
        operation: "Операција",
        edit: "Уреди",
        saveEdit: "Сачувај измене",
        add: "Додај",
        save: "Сачувај",
        setting: "Поставке",
        program: "Програм",
        unbind: "Разповежите",
        sleep: "Спавање",
        wakeup: "Пробуди",
        restart: "Поновно покретање",
        shutdown: "Игаси",
        reportLog: "Пријавите дневник",
        clearPlayData: "Обришите податке прегледања за постављање",
        offlineWarn: "Овај уређај је ван мреже, молимо покушајте поново када је уређај у мрежи！",
        confirmUnbind: "Потврдите разповезување",
        confirmReset: "Потврдите брисање",
        confirmDelete: "Потврдите брисање",
        delete: "Обриши",
        cancelDelete: "Откажите брисање",
        confirmResetSuccess: "Брисање успешно",
        confirm: "Потврдите",
        cancel: "Откажите",
        operationSuccess: "Операција успешна",
        unbindSuccess: "Разповезување успешно",
        pleaseSelectDevice: "Изберите уређај",
        pleaseSelectOnlineDevice: "Изберите уређаје у мрежи",
        confirmMixOperation: "Изабрани уређаји укључују уређаје ван мреже, ове поставке неће бити примене на уређаје ван мреже. Да ли желите да наставите операцију？",
        pleaseSelectDate: "Изберите датум",
        reportSuccess: "Пријава успешна",
        deviceSetting: "Поставке уређаја",
        default: "Подразумевано",
        all: "Све",
        deviceList: "Листа уређаја",
        addDevice: "Додај уређај",
        department: "Одељење/организација",
        deviceType: "Разрешение",
        osType: "Систем терминала",
        onlineState: "Статус повезаности",
        online: "У мрежи",
        offline: "Ван мреже",
        notActive: "Није активирано",
        search: "Унесите кључне речи",
        batchOperation: "Групне операције",
        allDevices: "Сви уређаји",
        deviceAttribute: "Атрибути уређаја",
        selectReportDate: "Изберите датум пријаве",
        inputName: "Унесите назив",
        inputWidth: "Унесите ширину",
        inputHeight: "Унесите висину",
        inputResolutionRatio: "Унесите целобројну вредност већу од 0！",
        inputSort: "Унесите сортирање",
        serialNum: "Регистарски број",
        name: "Назив",
        width: "Ширина",
        height: "Висина",
        resolutionRatio: "Разрешение",
        inputResolutionRatioName: "Унесите назив разрешенија",
        sort: "Сортирање",
        personal: "Лично",
        system: "Систем",
        type: "Тип",
        systemDefaultSettingUneditable: "Подразумеване системске поставке не могу бити уређене!",
        systemDefaultSettingUnDeletable: "Подразумеване системске поставке не могу бити обрисане!",
        newz: "Додај ново",
        total: "Укупно",
        totalNum: "записа",
        strategyName: "Назив стратегије",
        associatedTerminalNum: "Број повезаних терминала",
        createTime: "Време креирања",
        pleaseSelectStrategy: "Изберите стратегију！",
        onlySelectOneData: "Можете изабрати само један запис！",
        downloadStrategy: "Преузмите стратегију",
        inputStrategyName: "Унесите назив стратегије",
        luminanceControl: "Контрола осветљености",
        volumeStrategy: "Стратегија звучног нивоа",
        saveSuccess: "Чување успешно",
        screenAngle: "Ротација екрана(°)",
        startTime: "Време почетка",
        endTime: "Време завршетака",
        repeat: "Понављање",
        monday: "Понедељак",
        tuesday: "Уторак",
        wednesday: "Среда",
        thursday: "Четвртак",
        friday: "Петак",
        saturday: "Субота",
        sunday: "Недеља",
        everyday: "Сваки дан",
        downloadSpeed: "Брзина преузимања",
        inputDownloadSpeed: "Унесите брзину преузимања",
        operator: "Операција",
        pleaseSelectDeleteData: "Изберите податке за брисање！",
        confirmBatchDelete: "Да ли сте сигурни да желите да обришете одабране ставке групно？",
        pleaseInputName: "Унесите назив",
        detailSetting: "Детаљне поставке",
        weekPlan: "Недељни план",
        specialDateSetting: "Поставке посебних датума",
        weekdayInfo: "Недељни дан је обавезан!",
        volumeInfo: "Звучни ниво је обавезан!",
        timeError: "Погрешан избор времена!",
        editSuccess: "Уређивање успешно！",
        addSuccess: "Додавање успешно！",
        addSpecialPlan: "Додај посебни план стратегије",
        downloadSpeedInfo: "Брзина преузимања:(0 значи забрана преузимања)",
        pleaseSelectStartTime: "Изберите време почетка",
        pleaseSelectEndTime: "Изберите време завршетака",
        luminanceError: "Унесите исправну вредност осветљености！",
        defaultLuminance: "Подразумевана осветљеност",
        luminance: "Величина осветљености",
        defaultLuminanceInfo: "Подразумевана осветљеност(100 значи најјача, 0 значи најслаба)",
        volume: "Звучни ниво",
        saveLuminance: "Сачувај осветљеност",
        changeSuccess: "Промена успешна！",
        changeNetwork: "Промените мрежу",
        netName: "Назив мреже",
        nameempty: "Назив мреже не може бити празан",
        currentNetwork: "Тренутна мрежа",
        ipAddress: "IP адреса",
        dailyMode: "Данашњи режим",
        weeklyMode: "Недељни режим",
        turnOnTime: "Време уклањања у рад",
        turnOffTime: "Време игасања",
        startSleep: "Почетак спавања",
        endSleep: "Крај спавања",
        batchDelInfo: "Да ли сте сигурни да желите да обришете одабране ставке？",
        timeCannotBeEmpty: "Време не може бити празно!",
        startUp: "Уклони у рад",
        shutDown: "Игаси",
        volumeSize: "Величина звучног нивоа",
        defaultVolume: "Подразумевани звучни ниво(100 значи највећи, 0 значи утишина)",
        chooseStartTime: "Изберите време почетка",
        chooseEndTime: "Изберите време завршетака",
        saveVolume: "Сачувај звучни ниво",
        screenRotationUnSaved: "Ротација екрана није сачувана",
        volumeSettingUnSaved: "Поставке звучног нивоа није сачуване",
        luminanceSettingUnSaved: "Поставке осветљености није сачуване",
        confirmClosePopup: "Да ли сте сигурни да желите да затворите овај поп-ап прозор?",
        volumeSettingSuccess: "Измена звучног нивоа успешна",
        luminanceSettingSuccess: "Измена осветљености успешна",
        advancedSettingUnSaved: "Напредне поставке није сачуване",
        settingTitle: "Поставке терминала",
        volumeSetting: "Поставке звучног нивоа",
        luminanceSetting: "Поставке осветљености",
        downloadSetting: "Поставке преузимања",
        sleepSetting: "Поставке спавања",
        onOffSetting: "Периодичко уклањање у рад/игасање",
        namingError: "Грешка у именовању, датотека не сме садржати размаке！",
        deleteSuccess: "Брисање успешно",
        deleteFolder: "Обриши фасциклу",
        pleaseInputDeviceName: "Унесите назив уређаја",
        pleaseInputDeviceId: "Унесите ИД уређаја",
        discoverDevice: "Откријите уређај",
        deviceId: "ИД уређаја",
        bound: "Повезано",
        bind: "Повежи",
        noDevice: "Нема уређаја",
        refresh: "Освежите",
        manualAdd: "Ручно додај",
        deviceGroup: "Класификација уређаја",
        pleaseSelectGroup: "Изберите групу！",
        deviceName: "Назив уређаја",
        goAdd: "Идите да додате",
        close: "Затворите",
        bindCountInsufficient: "Доступан број повезаних уређаја је недовољан, молимо пронапредујте број уређаја пре додавања！",
        displayNumber: "Приказни број",
        groupName: "Назив групе",
        pleaseSelectGroupName: "Унесите назив групе！",
        moveGroup: "Преместите групу",
        longitude: "Дужина",
        latitude: "Ширина",
        nationality: "Држава",
        province: "Провинција",
        city: "Град",
        county: "Општина",
        outNetIp: "Изворна IP адреса",
        inNetIp: "Унутрашња IP адреса",
        companyName: "Назив предузећа",
        Info: "Детаљи",
        android: "Андроид",
        win: "Виндовс",
        osVersion: "Извор системске верзије",
        softwareVersion: "Верзија софтвера",
        diskSize: "Величина диска",
        useSize: "Коришћена величина",
        macAddr: "MAC адреса",
        longitudeLatitudeInfo: "Дужина и ширина морају бити обе празне или обе непразне!",
        terminalName: "Назив терминала",
        terminalGroup: "Група терминала",
        reportJournal: "Да ли је пријављено",
        systemVersion: "Верзија система",
        storageSpace: "Простор за складиштење",
        resolution: "Разрешение",
        runningMemory: "Радна меморија",
        model: "Модел",
        registerStatus: "Статус регистрације",
        password: "Лозинка",
        passwordInfo: "Унесите 6 до 18 слова или цифара!",
        group: "Група",
        address: "Адреса",
        remark: "Белешка",
        renewalPeriod: "Период пролонгације",
        money: "Трошак",
        latitudeInfo: "Унесите исправну ширину!",
        totalPayment: "Укупан износ",
        longitudeInfo: "Унесите исправну дужину!",
        setMeal: "Пакет",
        number: "Количина",
        programName: "Назив програма",
        playStatus: "Статус постављања",
        playType: "Начин постављања",
        play: "Постави",
        pause: "Пауза",
        playTime: "Време постављања",
        programDeleted: "Програм је обрисан",
        playSuccess: "Програм је распоређен за постављање",
        pauseSuccess: "Пауза успешна",
        playCycle: "Ротација",
        playInsert: "Уметните постављање",
        withdrawSuccess: "Повлачење успешно",
        withdrawInfo: "Молимо прво изаберите програм за повлачење！",
        programBelong: "Припадајући програм",
        checkAll: "Означи све",
        batchDel: "Групно брисање",
        delConfirm: "Да ли сте сигурни да желите да обришете одабране ставке？",
        check: "Означено",
        noProgram: "Нема програма",
        details: "Детаљи",
        screenshotFail: "Снимак екрана неуспешан",
        policyName: "Назив политике",
        terminalNum: "Број повезаних терминала",
        powerStrategy: "Стратегија напајања",
        pleaseSelectDepartment: "Изберите одељење！",
        screenshotControl: "Контрола снимка екрана",
        未激活: "Није активирано",
        已激活: "Актирано",
        未绑定: "Није повезано",
        已绑定: "Повезано",
    },
    programManage: {
        programList: "Листа програма",
        publishProgram: "Историјат објављивања програма",
        week1: "Понедељак",
        week2: "Уторак",
        week3: "Среда",
        week4: "Четвртак",
        week5: "Петак",
        week6: "Субота",
        week7: "Недеља",
        monday: "Први дан недеље",
        tuesday: "Други дан недеље",
        wednesday: "Трећи дан недеље",
        thursday: "Четврти дан недеље",
        friday: "Пети дан недеље",
        saturday: "Шести дан недеље",
        sunday: "Седми дан недеље",
        name: "Назив",
        preview: "Преглед",
        playDeviceNum: "Број уређаја за постављање",
        copyDeviceCode: "Кликните за копирање",
        osType: "Тип система",
        playDate: "Датум постављања",
        playWeek: "Недеља постављања",
        everyday: "Сваки дан",
        start: "од",
        end: "до",
        playOperateStatusStr: "Статус објављивања",
        playDevice: "Уређај за постављање",
        downloadView: "Преузмите и погледајте",
        publisher: "Објављивалац",
        publishTime: "Време објављивања",
        operation: "Операција",
        add: "Додај",
        groupName: "Назив групе",
        selectDevice: "Изберите терминал",
        searchDevice: "Претражите терминал",
        pleaseFillGroupName: "Унесите назив групе！",
        remarkInfo: "Белешка",
        compile: "Уреди",
        withdrawConfirm: "Да ли сте сигурни да желите да повучете овај програм？",
        confirm: "Потврдите",
        cancel: "Откажите",
        withdraw: "Повучите",
        batchWithdraw: "Групно повлачење",
        batchPublish: "Групно објављивање",
        batchDelete: "Групно брисање",
        batchOperation: "Групне операције",
        notUse: "Није кориштено",
        notChecked: "Није проверено",
        notPass: "Није прошла",
        delete: "Обриши",
        publishTextLeft: "Објављено",
        offTextLeft: "Паузирано",
        pleaseSelectProgramToMove: "Изберите програм за премештање！",
        pause: "Пауза",
        pauseConfirm: "Да ли сте сигурни да желите да паузирате？",
        play: "Поставите",
        downloadUdisk: "Преузмите на У диск",
        deviceList: "Листа уређаја",
        groupSelection: "Изабор групе",
        operationSuccess: "Операција успешна",
        deleteSuccess: "Брисање успешно",
        selectDate: "Изберите датум",
        publishStatus: "Статус објављивања",
        checkStatus: "Статус проверке",
        waitAuditing: "На чекању на проверу",
        auditPass: "Проверено успешно",
        auditRefuse: "Одбијено при проверци",
        all: "Све",
        playStatus: "У току постављања",
        playStatust: "Статус постављања",
        pauseStatus: "Паузирано",
        notStartStatus: "Није почело",
        resolutionratio: "Разрешение",
        totalNum: "записа",
        programName: "Назив програма",
        playStartTime: "Време почетка постављања",
        playEndTime: "Време завршетака постављања",
        createTime: "Време креирања",
        nationality: "Држава",
        province: "Провинција",
        city: "Град",
        county: "Општина",
        address: "Адреса",
        ip: "IP адреса",
        location: "Локација",
        log: "Дневник",
        pleaseFillProgramName: "Унесите назив програма！",
        selectGroup: "Изберите групу",
        startTime: "Време почетка",
        endTime: "Време завршетака",
        publishCycle: "Циклус објављивања",
        publishDeviceNum: "Број објављених уређаја",
        pleaseSelectRecord: "Изберите запис",
        deviceName: "Назив терминала",
        deviceId: "ИД терминалног уређаја",
        deviceGroupIdName: "Припадајућа група",
        notClassified: "Некласификовано",
        osTypeStr: "Систем терминала",
        storageSpace: "Простор за складиштење",
        onLineStatus: "Статус повезаности",
        onLine: "У мрежи",
        offLine: "Ван мреже",
        sleep: "Спавање",
        unknown: "Непознато",
        registerStatus: "Статус регистрације",
        trialPeriod: "Испробни период",
        notActive: "Није активирано",
        active: "Актирано",
        parameterError: "Погрешни параметри!",
        pleaseSelectProgram: "Изберите програм!",
        pleaseSelectProgramEdit: "Изберите програм за уређивање!",
        confirmWithdrawSelectedProgram: "Да ли сте сигурни да желите да повучете одабране програме？",
        withdrawSuccess: "Повлачење успешно",
        allPrograms: "Сви програми",
        defaultGroup: "Подразумевана група",
        cannotShareEmptyProgram: "Не можете да поделите празан програм！",
        onlyShareYourProgram: "Можете да поделите само програме које сте створили!",
        pleaseSelectProgramEditPublishTime: "Изберите програм за уређивање времена објављивања!",
        pleaseSelectDevice: "Изберите уређај!",
        programDetail: "Детаљи програма",
        errorReason: "Разлог грешке",
        availableStorageSpaceInsufficient: "Недовољан доступан простор за складиштење",
        partialDeviceReleaseFailure: "Неуспешно објављивање на део уређаја",
        allDeviceReleaseSuccess: "Објављивање на све уређаје успешно",
        partialDeviceReleaseSuccess: "Објављивање на део уређаја успешно",
        allGroup: "Све групе",
        allProgram: "Сви програми",
        unGrouped: "Негрупирано",
        replaceProgram: "Замените програм",
        replaceProgramTip: "Ново објављени програм ће заменити постојеће податке програма на уређају за постављање！",
        screen: "Један/два екрана",
        singleScreen: "Један екран",
        doubleScreen: "Два екрана",
        playSetting: "Поставке постављања",
        batchPlaySetting: "Групне поставке времена постављања",
        individualPlaySetting: "Појединачне поставке времена постављања",
        playTime: "Време постављања",
        daily: "Сваки дан",
        weekdays: "Понедељак до петка",
        monthly: "Текући месец",
        advancedSetting: "Напредне поставке",
        playProgram: "Поставите програм",
        searchProgram: "Унесите кључне речи",
        shareAddressNotExist: "Адреса за дељење не постоји, молимо покушајте поново",
        copySuccess: "Копирање успешно",
        shareLink: "Веза за дељење",
        publish: "Објавите",
        noResource: "Нема ресурса",
        single: "Један екран",
        double: "Два екрана",
        time: "Време",
        associatedTerminalNum: "Број повезаних терминала",
        default: "Подразумевано",
        moveGroup: "Преместите групу",
        pleaseSelectGroup: "Унесите назив групе！",
        copy: "Копирај",
        FUBEN: "Копирање",
        nameempty: "Назив не може бити празан",
        whitespace: "Грешка у именовању, датотека не сме садржати размаке！",
        programWhitespace: "Грешка у именовању, назив програма не сме садржати размаке！",
        pleaseSelectResolution: "Изберите разрешение！",
        dataError: "Погрешни подаци！",
        createProgram: "Креирај нови програм",
        directCreate: "Право креирање",
        myTemplate: "Моји шаблони",
        use: "Користите",
        free: "Бесплатно",
        loadMore: "Учитајте више",
        confirmDelete: "Потврдите брисање",
        deleteGroup: "Обриши групу",
        notPublished: "Није објављено",
        notPassed: "Није прошла",
        notUsed: "Није кориштено",
        confirmDeleteSelectedProgram: "Да ли сте сигурни да желите да обришете одабране програме？",
        companyName: "Назив предузећа",
        programCannotDownload: "Овај програм не може бити преузет！",
        publishMaterial: "Објавите материјал",
        playMaterial: "Поставите материјал",
        pleaseInputMaterialName: "Унесите назив материјала",
        size: "Величина",
        pleaseInputDeviceName: "Унесите назив уређаја",
        item: "ставки",
        allMaterial: "Сви материјали",
        allDevices: "Сви уређаји",
        "saveSuccess": "Успешно сачувано",
        "savefaill": "Неуспешно сачувано",
        "playMode": "Режим репродукције",
        "cyclePlay": "Циклична репродукција",
        "insertPlay": "Уметнута репродукција",
        "noData": "Нема података",
        "Add": "Додај",
        "replace": "Замени",
        "repeat": "Повтори",
        "start01": "Почетак",
        "end01": "Крај",
        "startDate": "Датум почетка",
        "endDate": "Датум краја",
        "useNow": "Користи odmah",
        "fillStartEndTimeFirst": "Молимо попуните време почетка и краја пре додавања",
        "fillFullPlayTime": "Молимо попуните потпуно време репродукције",
        "fillCorrectPlayTime": "Молимо попуните тачан период репродукције",
        "sDateAndEDateBothEmptyOrFilled": "Датум почетка и датум краја морају бити оба празна или оба попуњена"
    },
    source: {
        addResource: "Додај ресурс",
        width: "Ширина",
        height: "Висина",
        size: "Величина(KB)",
        name: "Назив",
        pleaseInputResourceName: "Унесите назив ресурса！",
        addToGroup: "Додајте у групу",
        remark: "Белешка",
        promptFgIllustrate: "Илустрација",
        promptFgRealisticPhoto: "Реалистична фотографија",
        promptFgSimplisticDrawing: "Једноставно цртање",
        promptFgChineseStyle: "Кинески стил",
        promptFgPixelArt: "Пиксел уметност",
        noModel: "Нема модела, молимо контактирајте администратора！",
        getModelFailed: "Неуспешно додавање модела, молимо покушајте поново касније！ Или контактирајте администратора！",
        createImagePrompt: "Слика се генерише, молимо затворите касније！",
        promptEmpty: "Унесите подсетник",
        dpiEmpty: "Изберите однос слике！",
        fgEmpty: "Изберите стил！",
        style: "Стил",
        idEmpty: "ИД слике не може бити празан",
        exist: "Ова слика већ постоји у материјалима",
        addSuccess: "Додавање материјала успешно",
        saveError: "Неуспешно чување слике, молимо покушајте поново касније！",
        delSuccess: "Брисање успешно",
        generateImage: "Текст у слику",
        generateImagePlaceholder: "Унесите слику коју желите да генеришете, на пример: Лепирка плесе у цвућој ниви",
        aiExpand: "Интелектуелно проширење",
        negativePrompt: "Позитивни подсетник",
        negativePromptTooltip: "Коришћење за јасно искључивање садржаја или карактеристика које корисник не жели да се појаве у излазу",
        imageRatio: "Однос слике",
        generateImageBtn: "Генеришите одмах",
        shengchengjieguo: "Резултат генерације",
        generateImageLoadingTip: "У току генерације, молимо не кликате поново или затварајте...",
        Tooltip: "Хајде да AI вашу креативност",
        saveToMaterial: "Сачувајте у материјале",
        publish: "Објавите одмах",
        download: "Преузмите",
        generateHistory: "Историјат генерације",
        hide: "Скупајте",
        cancel: "Откажите",
        useExpand: "Користите проширење",
        all: "Све",
        delete: "Обриши",
        loadMore: "Учитајте више",
        aiTip: "Садржај је генерисан моделом вештачке интелигенције и не представља ставове, положаје или ставове платформе. Молимо користите AI садржај на исправан и законит начин",
        operationSuccess: "Операција успешна",
        moveGroup: "Преместите групу",
        groupName: "Назив групе",
        pleaseSelectGroup: "Изберите назив групе！",
        shenhe: "Провера",
        shenheStatus: "Статус проверке",
        shenheSuccess: "Проверено успешно",
        shenheRefuse: "Одбијено при проверци",
        pleaseSelectShenheStatus: "Изберите статус проверке！",
        shenheRemark: "Белешка о проверци",
        pleaseInputShenheRemark: "Унесите белешку о проверци！",
        pleaseInputFileName: "Унесите назив датотеке！",
        whitespace: "Грешка у именовању, датотека не сме садржати размаке！",
        dataError: "Погрешни подаци！",
        confirmDelete: "Потврдите брисање",
        confirm: "Потврдите",
        deleteFolder: "Обриши фасциклу",
        add: "Додај",
        edit: "Уреди",
        fileName: "Назив датотеке",
        group: "Група",
        resolution: "Разрешение",
        type: "Тип",
        image: "Слика",
        music: "Музика",
        video: "Видео",
        uploadTime: "Време отпремања",
        uploadUser: "Корисник који је отправио",
        checkTime: "Време проверке",
        checkUser: "Корисник који је проверио",
    },
    setting: {
        nameempty: "Назив не може бити празан",
        heightempty: "Висина не може бити празна",
        widthempty: "Ширина не може бити празна",
        resolutionratio: "Разрешение",
        name: "Назив",
        opteration: "Операција",
        compile: "Уреди",
        delete: "Обриши",
        newz: "Додај ново",
        compileratio: "Уреди разрешение",
        sheizhifenbianlvmingcheng: "Поставите назив разрешенија",
        shezhigaodu: "Поставите висину",
        shezhikuandu: "Поставите ширину",
        xinzengfenbianlv: "Додај ново разрешение",
        bianma: "Код",
        bianjizhongduanmingcheng: "Уреди назив терминала",
        xinzengzhongduan: "Додај нови терминал",
        selectPrimaryColor: "Изберите боју теме",
        fullScreen: "Цео екран",
        exitFullScreen: "Изађите из целог екрана",
    },
    tabs: {
        refresh: "Освежите",
        refreshAll: "Освежите све",
        close: "Затворите",
        closeOthers: "Затворите остале",
        closeAll: "Затворите све",
        closeLeft: "Затворите леве",
        closeRight: "Затворите десне",
    },
    errorPage: {
        needLogin: "Још увек нисте пријављени！",
        pageNotFound: "Пријављена страница не постоји！",
        redirectTo: "Преусмерите на",
        orReturn: "или се вратите",
        previousStep: "Претходни корак",
    },
    headerUs: {
        systemNotice: "Системско обавештење",
        allNotices: "Сва обавештења",
        viewAllMessages: "Погледајте све поруке",
        contactUs: "Контактирајте нас",
        operationSuccess: "Операција успешна！",
        leaveMessage: "Пошаљите нам поруку",
        messageTitle: "Наслов",
        messageTitleTip: "Унесите наслов！",
        messageContentTip: "До 150 карактера",
        submit: "Пошаљите",
        markAsRead: "Обележите као прочитано",
        success: "Операција успешна！"
    },
    material: {
        allMaterial: "Сви материјали",
        defaultGroup: "Подразумевана група",
        auditStatus: "Статус проверке",
        auditPassed: "Проверено успешно",
        auditRejected: "Одбијено при проверци",
        pendingAudit: "На чекању на проверу",
        all: "Све",
        operateSuccess: "Операција успешна！",
        pleaseSelectMaterial: "Изберите материјал！",
        moveGroup: "Преместите групу",
        pleaseSelectGroup: "Изберите групу！",
        batchPublish: "Групно објављивање",
        batchRecall: "Групно повлачење",
        batchDelete: "Групно брисање",
        materialList: "Листа материјала",
        uploadMaterial: "Отпремите материјал",
        materialType: "Тип материјала",
        pleaseInputMaterialName: "Унесите назив материјала",
        selectAll: "Означи све",
        confirmDeleteSelectedMaterial: "Да ли сте сигурни да желите да обришете одабране материјале？",
        deleteSuccess: "Брисање успешно",
        delete: "Обриши",
        publish: "Објавите",
        recall: "Повучите",
        confirmRecallSelectedMaterial: "Да ли сте сигурни да желите да повучете одабране материјале？",
        pleaseSelectMaterialGroup: "Изберите групу материјала！",
        recallSuccess: "Повлачење успешно",
        publishSuccess: "Објављивање успешно",
        batchOperate: "Групне операције",
        item: "ставки",
        confirmDelete: "Потврдите брисање？",
        edit: "Уреди",
        confirmRecall: "Потврдите повлачење？",
        unaudited: "Није проверено",
        notPassed: "Није прошла",
        operate: "Операција",
        resolution: "Разрешение",
        none: "Нема",
        confirm: "Потврдите",
        cancel: "Откажите",
        AICreation: "Израдивање AI",
    },
    uploadFile: {
        operationSuccess: "Операција успешна",
        uploadFile: "Управљање отпремањем",
        uploadSuccess: "Отпремање успешно",
        uploadCompleted: "Отпремање завршено",
        uploadFail: "Отпремање неуспешно",
        ConversionFailed: "Конверзија неуспешна！",
        loading: "Учитавање...",
        beQueuing: "На чекању...",
        Uploading: "Отпремање у току...",
        ConversionIng: "Конверзија у току...",
        ConventionalResources: "Конвенционални ресурси",
        DocumentResources: "Ресурси документа",
        complete: "Завршено",
        upload: "Отпремите",
        fileSizeWraning01: "Величина материјала прелази",
        fileSizeWraning02: "молимо измените и отпремите поново！",
        fileIsEmpty: "Датотека је празна",
        uploadFileTip: "Неподржани формат датотеке",
        unablePreview: "Није успешно додато у материјале, преглед није могућ",
        confirmDelete: "Потврдите брисање？",
        deleteSuccess: "Брисање успешно",
        delete: "Обриши",
        confirm: "Потврдите",
        preview: "Преглед",
        close: "Затворите",
        cancel: "Откажите",
        fileType: "Тип датотеке",
        fileSize: "Величина датотеке",
        conversionProgress: "Напредак конверзије",
        progress: "Напредак",
        image: "Слика",
        video: "Видео",
        audio: "Музика",
        limitTip01: "Једном отпремите",
        limitTip02: "датотека",
        okTip: "Отпремате материјал, молимо затворите касније！",
        usableSize: "Доступна капацитет",
        sizeUnableTip: "Тренутно је недовољан доступан простор за складиштење, молимо временски обришите непотребне материјале како бисте сачували простор или контактирајте дистрибутера за проширење капацитета облачног складишта. Ова услуга може да носи трошкове, деталије се молимо потражите код дистрибутера.",
        view: "Погледајте детаље",
        fileName: "Назив датотеке",
    },
    template: {
        inputPlaceholder: "Унесите",
        selectPlaceholder: "Изберите",
        noAuths: "Нема овлашћења, молимо контактирајте администратора",
        operationSuccess: "Операција успешна",
        total: "Укупно",
        totalNum: "записа",
        dan: "Један",
        shaung: "Два",
        pleaseSelectGroup: "Изберите групу",
        preview: "Преглед",
        free: "Бесплатно",
        use: "Користите",
        dpi: "Разрешение",
        delete: "Обриши",
        confirmDelete: "Потврдите брисање",
        confirmDeleteSelectedTemplate: "Да ли сте сигурни да желите да обришете овај шаблон",
        push: "Објавите",
        pushConfirm: "Да ли сте сигурни да желите да објавите у јавни шаблон",
        pushRemovalConfirm: "Да ли сте сигурни да желите да искључите из јавног шаблона",
        templateOrderRecord: "Историјат поручених шаблона",
        unpublished: "Није објављено",
        auditing: "У току проверке",
        publishRejected: "Одбијено при објављивању",
        publishSuccess: "Објављивање успешно",
        offShelf: "Искључите",
        公共模版: "Јавни шаблони",
        我的模板: "Моји шаблони",
        共享记录: "Историјат дељења",
        name: "Назив",
        pubdate: "Време објављивања",
        keySeachTip: "Унесите кључне речи",
        allGroup: "Све групе",
        add: "Додај",
        edit: "Уреди",
        programName: "Назив програма",
        selectGroup: "Изберите групу",
    },
    checkManage: {
        total: "Укупно",
        totalNum: "записа",
        operationSuccess: "Операција успешна",
        checkUserLogs: "Историјат проверке (оператор)",
        checkLogs: "Историјат проверке (проверявач)",
        sourceCheck: "Провера материјала",
        programCheck: "Провера програма",
        checkAll: "Означи све",
        auditPass: "Проверено успешно",
        auditRefuse: "Одбијено при проверци",
        auditPass01: "Прошло",
        auditRefuse01: "Одбијено",
        auditRefuse02: "Одбијено при проверци",
        auditor: "Проверявач",
        agentUserName: "Објављивалац",
        interrogationTime: "Време постављања на проверу",
        checkTime: "Време проверке",
        checkName: "Назив проверке",
        checkType: "Категорија проверке",
        checkIp: "IP адреса постављања на проверу",
        checkReason: "Порука",
        checkStatus: "Садржај операције",
        rangePicker: "Датум проверке",
        keyWord: "Кључне речи",
        all: "Све",
        program: "Програм",
        material: "Материјал",
        dan: "Један",
        shaung: "Два",
        pleaseSelectProgram: "Изберите програм!",
        pleaseSelectMaterial: "Изберите материјал！",
        preview: "Преглед",
        dpi: "Разрешение",
        auditRefuseTip: "Унесите разлог одбијања",
        unreviewed: "Није проверено",
        notPassed: "Није прошла",
        notUsed: "Није кориштено",
        edit: "Уреди",
        none: "Нема",
        name: "Назив",
        size: "Величина",
        type: "Тип",
        uploadTime: "Време отпремања",
        uploadUser: "Корисник који је отправио",
        checkUser: "Корисник који је проверио",
        image: "Слика",
        music: "Музика",
        video: "Видео",
    },
    systemSet: {
        total: "Укупно",
        totalNum: "записа",
        inputPlaceholder: "Унесите",
        selectPlaceholder: "Изберите",
        userList: "Чланови организације",
        roleList: "Овлашћења улога",
        department: "Организациона структура",
        diskInfo: "Простор за складиштење",
        approveSet: "Одобрење садржаја",
        logList: "Управљање дневником",
        name: "Име",
        account: "Назив налога",
        userName: "Име корисника",
        phoneNumber: "Број мобилног телефона",
        role: "Улога",
        createTime: "Време креирања",
        operation: "Операција",
        edit: "Уреди",
        delete: "Обриши",
        addNew: "Додај ново",
        add: "Додај",
        resetPassword: "Ресетујте лозинку",
        confirmDelete: "Потврдите брисање",
        departmentOrganization: "Одељење/организација",
        addNewUser: "Додај новог корисника",
        pleaseEnterUserName: "Унесите име корисника",
        confirmPasswordNotMatch: "Потврдна лозинка се не поклапа са лозинком!",
        operationSuccess: "Операција успешна！",
        userNickname: "Назив корисника",
        pleaseEnterUserNickname: "Унесите назив корисника",
        userNicknameRequired: "Назив корисника не може бити празан！",
        password: "Лозинка",
        pleaseEnterPassword: "Унесите лозинку",
        passwordRequired: "Лозинка не може бити празна！",
        passwordTip: "Вашата лозинка је превише слаба (лозинка мора садржати 3 од следећих: велика слова, мала слова, цифре, специјални карактери и дужину од 8",
        confirmPassword: "Потврдите лозинку",
        pleaseEnterPhoneNumber: "Унесите број мобилног телефона",
        phoneNumberRequired: "Број мобилног телефона не може бити празан！",
        phoneNumberFormatError: "Унесите исправан број мобилног телефона！",
        roleRequired: "Улога не може бити празна！",
        required: "Не може бити празно！",
        departmentName: "Одељење",
        modifyPassword: "Измени лозинку",
        newPassword: "Нова лозинка",
        pleaseEnterNewPassword: "Унесите нову лозинку",
        pwdMessage: "Лозинка мора имати 8~20 карактера, без размака и мора садржати 3 од следећих: велика слова, мала слова, цифре, специјални карактери",
        all: "Све",
        noAuths: "Нема овлашћења, молимо контактирајте администратора",
        departmentName01: "Назив одељења",
        image: "Слика",
        music: "Музика",
        video: "Видео",
        buySize: "Куповна количина",
        totalMoney: "Укупан износ за плаћање",
        buycreateTime: "Време куповине",
        endTime: "Време истека",
        buyTypeStr: "Тип поручине",
        sourceCheck: "Провера материјала",
        programCheck: "Провера програма",
        programName: "Назив програма",
        diskExpansion: "Предлаже се да временски обришите истекле/некоришћене материјале током употребе како бисте осигурали доступан простор система. Ако имате потребу за већим простором, можете контактирати добављача ваших уређаја за услугу проширења капацитета облачног складишта. Ова услуга може да носи трошкове, деталије се молимо потражите код дистрибутера.",
        selectPermission: "Изберите овлашћења",
        checkPermission: "Обележите овлашћења",
        addRole: "Додај улогу",
        enterRoleName: "Унесите назив улоге",
        roleName: "Назив улоге",
        roleNameRequired: "Назив улоге не може бити празан！",
        remark: "Белешка",
        enterRemark: "Унесите белешку",
        permissionSetting: "Поставке овлашћења",
        deleteSuccess: "Брисање успешно！",
        confirmToDelete: "Потврдите брисање？",
        orgName: "Назив организације",
        orgNameRequired: "Назив организације не може бити празан！",
        orgRemark: "Белешка о организацији",
        enterOrgRemark: "Унесите белешку о организацији",
        capacityUsage: "Статус употребе капацитета",
        usedCapacity: "Коришћени капацитет",
        totalCapacity: "Укупан капацитет",
        remainingCapacity: "Преостали капацитет",
        capacityExpansion: "Проширење капацитета",
        enable: "Омогућите",
        disable: "Онемогућите",
        userName01: "Назив корисника",
        loginTime: "Време пријаве",
        ipAddress: "IP адреса",
        loginResult: "Резултат пријаве",
        selectDate: "Изберите датум",
        enterDate: "Изберите датум",
        selectStartTime: "Изберите време почетка",
        selectEndTime: "Изберите време завршетака",
        enterUserName: "Унесите назив корисника",
        userCount: "Број корисника",
        roleDesc: "Опис улоге",
        roleAuthorization: "Ауторизација улоге",
        success: "Успешно",
        failure: "Неуспешно",
        time: "Време",
        operationContent: "Садржај операције",
        playCount: "Број постављања",
        playDuration: "Трајање постављања",
        selectDevice: "Изберите уређај",
        enterProgramName: "Унесите назив програма",
        serialNumber: "Регистарски број",
        publishContentName: "Назив објављеног садржаја",
        playMode: "Начин постављања",
        cyclePlay: "Ротација",
        insertPlay: "Уметните постављање",
        paddingPlay: "Додатно постављање",
        playDeviceId: "ИД уређаја за постављање",
        playDeviceName: "Назив уређаја за постављање",
        publishTime: "Време објављивања",
        downloadStatus: "Статус преузимања",
        notDownloaded: "Није преузето",
        downloading: "У току преузимања",
        downloadSucceeded: "Преузимање успешно",
        downloadFailed: "Преузимање неуспешно",
        enterPublishContentName: "Унесите назив објављеног садржаја",
        terminalId: "ИД терминала",
        belongOrg: "Припадајућа организација",
        reportTime: "Време пријаве",
        reportIp: "IP адреса пријаве",
        logInfo: "Информације о дневнику",
        details: "Детаљи",
        confirmDeletion: "Да ли сте сигурни да желите да обришете？",
        logDetails: "Детаљи дневника",
        download: "Преузмите",
        deptOrg: "Одељење/организација",
        query: "Претражите",
        queryByTerminalId: "Претражи по ИД терминала",
        batchDeleteLogs: "Групно брисање дневника",
        customTimeDeleteLogs: "Брисање дневника за произвољно време",
        selectTimeRangeFirst: "Прво изберите временски опсег",
        deleteAllDeviceLogsIfEmpty: "Ако не унесете ИД уређаја, подразумевано ће бити обрисани дневници свих уређаја",
        enterDeviceIdToDeleteLogs: "Унесите ИД уређаја за брисање дневника",
        confirmDeleteAction: "Потврдите брисање",
        selectDeleteRangeFirst: "Прво изберите опсег брисања",
        networkConnectionFailed: "Неуспешна повезаност са мрежом",
        playLog: "Дневник постављања",
        publishLog: "Дневник објављивања",
        errorLog: "Дневник грешака",
        operationLog: "Дневник операција",
        fileLog: "Дневник датотека",
        userOperateLog: "Дневник пријављивања",
    },
    userManual: {
        userManual: "Кориснички руковод",
        noData: "Нема података",
    },
    systemNotice: {
        systemNotice: "Системско обавештење",
        noData: "Нема података",
        total: "Укупно",
        totalNum: "записа",
        "markAllRead": "Обележите све као прочитано",
        "deleteAll": "Обриши све",
        "all": "Све",
        "unread": "Непрочитано",
        "read": "Прочитано",
        "type": "Тип",
        "content": "Садржај",
        "date": "Датум",
        "status": "Статус",
        "confirmDelete": "Потврдите брисање？",
        "confirm": "Потврдите",
        "cancel": "Откажите",
        "delete": "Обриши"
    }
};